import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";

const ExpiryDates = ({
  selectedSymbol,
  handleSymbolSelection,
  expiryDays,
  activeDate,
  showTitle = true,
  showDaysInButton = true,
}) => {
  const { theme } = useTheme();
  const [selectedExpiry, setSelectedExpiry] = useState(
    selectedSymbol?.option_expiries?.[0] || ""
  );

  const isToday = (dateStr) => {
    const today = new Date();
    const date = new Date(dateStr);
    return (
      today.getFullYear() === date.getFullYear() &&
      today.getMonth() === date.getMonth() &&
      today.getDate() === date.getDate()
    );
  };

  const getDaysDifference = (dateStr) => {
    const today = new Date();
    const date = new Date(dateStr);
    const diffTime = date - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // In days
  };

  const formatDifferenceLabel = (difference) => {
    if (difference === 0) {
      return "Expiring today";
    } else if (difference >= 365) {
      const years = Math.floor(difference / 365);
      return `+${years} year${years > 1 ? "s" : ""}`;
    } else if (difference >= 30) {
      const months = Math.floor(difference / 30);
      return `+${months} month${months > 1 ? "s" : ""}`;
    } else {
      return `+${difference} day${difference > 1 ? "s" : ""}`;
    }
  };

  const renderSelectedButtonLabel = () => {
    const difference = getDaysDifference(activeDate);

    return (
      <>
        {new Date(activeDate).toLocaleDateString("en-US", {
          day: "numeric",
          month: "short",
        })}
        {showDaysInButton && (
          <span className="expiry-days ms-1">
            ({formatDifferenceLabel(difference)})
          </span>
        )}
      </>
    );
  };

  const formatExpiryLabel = (dateStr) => {
    const difference = getDaysDifference(dateStr);

    return `${new Date(dateStr).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
    })} (${formatDifferenceLabel(difference)})`;
  };

  const handleExpirySelection = (expiryDate) => {
    setSelectedExpiry(expiryDate);
    handleSymbolSelection(selectedSymbol, expiryDate);
  };

  return (
    <div className="symbol-date mt-md-2 mt-md-3">
      <div className="flex items-center gap-1">
        {showTitle && (
          <div className="pe-1 pe-md-0 expiry-date-title">Expiry date:</div>
        )}
        <div className="dropdown">
          <button
            className="dropdown-toggle date-dropdown-btn flex items-center"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            type="button">
            {renderSelectedButtonLabel()}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="7"
              viewBox="0 0 13 7"
              fill="none"
              className="ms-2">
              <path
                d="M6.32426 7L0.262079 0.25L12.3864 0.25L6.32426 7Z"
                fill={theme === "dark" ? "#74B9F9" : "#383FEC"}
              />
            </svg>
          </button>

          <ul className="dropdown-menu oc-date-dropdown-menu py-0">
            {selectedSymbol?.option_expiries &&
              Array.isArray(selectedSymbol.option_expiries) &&
              selectedSymbol.option_expiries.map((expiryDate, index) => (
                <li
                  key={index}
                  className={`dropdown-item cursor-pointer ${
                    expiryDate === selectedExpiry ? "active" : ""
                  }`}
                  onClick={() => handleExpirySelection(expiryDate)}>
                  {formatExpiryLabel(expiryDate)}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ExpiryDates;
